import { IoIosAdd } from 'react-icons/io';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Left = styled.div`
  flex: 1;
`;

interface TitleProps {
  $subtitle: boolean;
}

export const Title = styled.h1<TitleProps>`
  font-weight: bold;
  font-size: 1.2em;
  line-height: ${({ $subtitle }) => ($subtitle ? '1.2em' : '40px')};
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Subtitle = styled.h2`
  font-weight: normal;
  font-size: 1em;
  color: ${ColorPalette.HEX.CharlestonGreen};
  line-height: 1.4em;
  & > strong {
    color: ${ColorPalette.HEX.OriolesOrange};
    font-weight: 600;
    font-size: 1.1em;
  }
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const CloseButton = styled.button`
  display: flex;
  cursor: pointer;
  background: none;
`;

export const CloseIcon = styled(IoIosAdd)`
  font-size: 30px;
  transform: rotate(45deg);
`;

export const Container = styled.div`
  display: flex;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid ${ColorPalette.HEX.BrightGray3};
  &.highlight {
    background: ${({ theme }) => theme.button.background};
    padding: 0 8px 0 16px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    & ${Title} {
      color: ${ColorPalette.HEX.White};
    }
    & .icons {
      color: ${ColorPalette.HEX.White};
    }
  }
`;
